import { VehicleRelatedDto } from "@1games-ru/region-shared/dist/types/vehicle/vehicle-b";
import * as Tooltip from "@radix-ui/react-tooltip";
import clsx from "clsx";
import { cn } from "@/core/helpers/cn";
import { Vehicle2Icon } from "@/shared/icons";

type Props = {
  address: VehicleRelatedDto["address"];
  className?: string;
};

export default function TransportWarehouseTransportAddress({ address, className }: Props) {
  return (
    <Tooltip.Provider delayDuration={150}>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>
          <button
            type="button"
            className={cn(
              "shrink-0 flex items-center justify-center size-6 bg-dark-700 rounded-md",
              className,
            )}
          >
            <Vehicle2Icon size={12} className="text-white transition-[fill]" />
          </button>
        </Tooltip.Trigger>

        <Tooltip.Portal>
          <Tooltip.Content
            side="top"
            align="center"
            sideOffset={8}
            className={clsx(
              "z-50 rounded-md bg-dark-800/90",
              "px-2.5 py-1 shadow-lg backdrop-blur",
            )}
          >
            <div className="text-14 font-bold text-gray whitespace-nowrap">
              {address.streetName}
            </div>
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
}
